import parser from 'ua-parser-js';

export function getPlatform():
	| 'mobile web'
	| 'desktop web'
	| 'webview android' {
	const platform = parser();
	if (
		platform?.browser?.name === 'Chrome WebView' &&
		platform?.os?.name === 'Android'
	)
		return 'webview android';

	const mobileDeviceTypes = ['mobile', 'tablet'];
	const isMobile = mobileDeviceTypes.includes(platform.device.type || '');
	return isMobile ? 'mobile web' : 'desktop web';
}
